import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Config } from '../config';
import { SavePermissionRequest, ValidationProviderDetails, QueryValidationsFilter } from '../models';

@Injectable()

export class ValidatorService {

  _validators: Array<Object> = [];
  _selectedValidatorOption: Object = {};

  constructor(
    private config: Config,
    private http: HttpClient
  ) { }

  getAllValidators(): Observable<Array<any>> {
    return this.http.get(this.config.get('API_SERVER_URL') + `/management/validationProviders`)
      .pipe(map((providers: Array<any>) => {
        this._validators = providers || [];
        return this._validators;
      }));
  }

  saveValidator(validator: ValidationProviderDetails): Observable<any> {
    return this.http.put(this.config.get('API_SERVER_URL') + '/management/validationProvider/details', validator);
  }

  saveValidatorOption(validationProviderFeatureRequest: any): Observable<any> {
    return this.http.put(this.config.get('API_SERVER_URL') + '/management/validationProvider/options', validationProviderFeatureRequest);
  }

  selectValidatorOption(validator): Observable<boolean> {
    return new Observable(observer => observer.next(this._selectedValidatorOption = validator));
  }

  getSelectedValidatorOption(): Observable<any> {
    return new Observable(observer => observer.next(this._selectedValidatorOption));
  }

  getValidationConfigsByProvider(id: string): Observable<Array<any>> {
    return this.http.get<Array<any>>(this.config.get('API_SERVER_URL') + `/management/validationConfigs/${id}`);
  }

  getAllValidationConfigs(active: boolean): Observable<Array<any>> {
    return this.http.get<Array<any>>(this.config.get('API_SERVER_URL') + `/management/validationConfigs?active=${active}`);
  }

  deleteValidationConfig(id: number): Observable<HttpResponse<void>> {
    return this.http.delete<HttpResponse<void>>(this.config.get('API_SERVER_URL') + `/management/validationConfiguration/${id}`);
  }

  getAllValidationConfigsPermissions(id: string): Observable<Array<any>> {
    return this.http.get<Array<any>>(this.config.get('API_SERVER_URL') + `/management/validationConfiguration/${id}/permission`);
  }

  removePermission(idUser: number, idValidationConfig: number): Observable<HttpResponse<void>> {
    return this.http.delete<HttpResponse<any>>(this.config.get('API_SERVER_URL') + `/management/validationConfiguration/${idValidationConfig}/permission/${idUser}`);
  }

  saveValidationConfiguration(validationConfiguration): Observable<any> {
    return this.http.put(this.config.get('API_SERVER_URL') + '/management/validationConfiguration', validationConfiguration);
  }

  addPermission(idUser: number, idValidationConfig: number): Observable<HttpResponse<any>> {
    let data: SavePermissionRequest = new SavePermissionRequest();
    console.log("idUser " + idUser);
    data.idAccessUser = idUser;
    console.log("idValidationConfig " + idValidationConfig);
    data.idValidationConfiguration = idValidationConfig;
    console.log(data);
    return this.http.put<HttpResponse<any>>(this.config.get('API_SERVER_URL') + '/management/validationConfiguration/permission', data);
  }

  getAllFeatures(): Observable<any> {
    return this.http.get(this.config.get('API_SERVER_URL') + '/management/features');
  }

  getAllTariffs(): Observable<any> {
    return this.http.get(this.config.get('API_SERVER_URL') + '/management/tariffs');
  }

  queryValidations(queryRequest: QueryValidationsFilter): Observable<Array<any>> {
    return this.http.post<Array<any>>(this.config.get('API_SERVER_URL') + '/validation/report', queryRequest);
  }

  queryValidationsXls(queryRequest: QueryValidationsFilter): Observable<any> {
    return this.http.post(this.config.get('API_SERVER_URL') + '/validation/report-document', queryRequest, { reportProgress: true, observe: 'response', responseType: 'blob' });
  }

}
